import { safetyColors, safetyType } from "@/safety/ui/tokens";

/**
 * Single source of truth for the module shells (Safety, Finance, ...) so their
 * tab bars and content containers stay visually identical.
 */
const CONTENT_PADDING = "1rem";
const CONTENT_PADDING_TOP = "0.5rem";

export const moduleShellTokens = {
  surfaceCard: safetyColors.white,
  surfacePage: safetyColors.surfaceAlt,
  border: safetyColors.border,
  tabColor: "var(--mela-text-muted)",
  tabColorSelected: "var(--mela-color-primary)",
  tabFontSize: safetyType.body,
  contentPaddingTop: CONTENT_PADDING_TOP,
  contentPadding: CONTENT_PADDING,
  pagePadding: `${CONTENT_PADDING_TOP} ${CONTENT_PADDING} ${CONTENT_PADDING}`,
  headerRowPaddingY: "12px",
  surfaceRadius: 8,
  surfaceBorder: `1px solid ${safetyColors.border}`,
  surfaceShadow: "0 6px 18px rgba(15, 23, 42, 0.08)",
  actionsGap: 6,
} as const;

export default moduleShellTokens;
